module.exports = __webpack_public_path__ + "img/D0.bbd56e38.webp";